import React, { useEffect } from "react";
import { useAuth } from "react-uicomp";
import CompWrapper from "../hoc/compWrapper/CompWrapper.hoc";

// IMAGES
import PLACEHOLDER from "../../assets/images/lab.jpg";
import { TitleB } from "../common/title/Title.common";

const LaboratoriesPage = () => {
  const { setHeaderTitle } = useAuth();

  useEffect(() => {
    setHeaderTitle("Laboratories");
  }, [setHeaderTitle]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <CompWrapper>
      <div className="mb-6">
        <TitleB title="Tissue culture lab" />
        <img className="image-showcase" width="60%" src={PLACEHOLDER} />
      </div>
      <div className="mb-6">
        <TitleB title="Soil lab" />
        <img className="image-showcase" width="60%" src={PLACEHOLDER} />
      </div>
      <div className="mb-6">
        <TitleB title="Entomology lab" />
        <img className="image-showcase" width="60%" src={PLACEHOLDER} />
      </div>
      <div className="mb-6">
        <TitleB title="Pathology" />
        <img className="image-showcase" width="60%" src={PLACEHOLDER} />
      </div>
    </CompWrapper>
  );
};

export default LaboratoriesPage;
